import { useApiError as useApiErrorContext } from '../contexts/ApiErrorContext';
import { useCallback } from 'react';
import { APIError, handleApiError } from '../utils/errorHandler';

export const useApiError = () => {
  const context = useApiErrorContext();

  const handleError = useCallback((error, options = {}) => {
    const skipByDefault = [401];
    
    if (skipByDefault.includes(error?.status) && !options.forceShow) {
      return;
    }

    const apiError = error instanceof APIError ? error : handleApiError(error);
    
    context.showError(apiError, options);
  }, [context]);

  const withErrorHandling = useCallback((asyncFunction, options = {}) => {
    return async (...args) => {
      try {
        return await asyncFunction(...args);
      } catch (error) {
        handleError(error, options);
        
        if (!options.suppressThrow) {
          throw error;
        }
      }
    };
  }, [handleError]);

  const createRetryHandler = useCallback((originalFunction, ...args) => {
    return () => originalFunction(...args);
  }, []);

  return {
    ...context,
    handleError,
    withErrorHandling,
    createRetryHandler
  };
};